import React from 'react';
import '../template-file-css/document-file-template.css';


export const LHH_ConsumerReferralForm = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LHH_ConsumerReferralForm' className='file-pdf-document'>

            <div className='file-template'>


            </div>
        </form>

    )
}







